import { eventTypes } from "common/apiDefinitions";
import { EventTypeColors } from "types/common";

export const isEventTypeColor = (
	arg: string | undefined
): arg is EventTypeColors => {
	if (!arg) return false;
	return eventTypes.includes(arg);
};
